import { render } from "./AskPeterWidget.vue?vue&type=template&id=0f65ada8&scoped=true"
import script from "./AskPeterWidget.vue?vue&type=script&lang=js"
export * from "./AskPeterWidget.vue?vue&type=script&lang=js"

import "./AskPeterWidget.vue?vue&type=style&index=0&id=0f65ada8&lang=css"
import "./AskPeterWidget.vue?vue&type=style&index=1&id=0f65ada8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f65ada8"]])

export default __exports__